document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.view-btn');
    const gridView = document.querySelector('.view-mode.grid-view');
    const listView = document.querySelector('.view-mode.list-view');

    // Load saved view from localStorage, default to grid
    const savedView = localStorage.getItem('productView') || 'grid';

    // Apply saved view
    if (savedView === 'list') {
        gridView.classList.remove('active');
        listView.classList.add('active');
        buttons.forEach(btn => {
            btn.classList.toggle('active', btn.dataset.view === 'list');
        });
    } else {
        gridView.classList.add('active');
        listView.classList.remove('active');
        buttons.forEach(btn => {
            btn.classList.toggle('active', btn.dataset.view === 'grid');
        });
    }

    // Button click to toggle and store preference
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const view = button.dataset.view;

            // Store view in localStorage
            localStorage.setItem('productView', view);

            // Toggle buttons
            buttons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');

            // Toggle views
            if (view === 'grid') {
                gridView.classList.add('active');
                listView.classList.remove('active');
            } else {
                listView.classList.add('active');
                gridView.classList.remove('active');
            }
        });
    });
});
